export default "__VITE_ASSET__r795oAV2__"